import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { editChartColor } from "store/actions";
import { withTranslation } from "react-i18next"
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { UncontrolledTooltip } from 'reactstrap';


const AddEditModal = props => {
    const { modal, toggle, isEdit, itemData, fetchChartColorListData } = props
    const [chartColorData, setChartColorData] = useState();
    const { error, success, loading,editLoading } = useSelector(state => ({
        loading: state.ConfigurationsChartColor.loading,
        editLoading:state.ConfigurationsChartColor.editLoading,
        error: state.ConfigurationsChartColor.error,
        success: state.ConfigurationsChartColor.success,
    }));
    const [rgb, setRgb] = useState({ r: 0, g: 0, b: 0, hex: '' });
    const dispatch = useDispatch();

    useEffect(() => {
        setChartColorData(itemData)
        setRgb({
            r: itemData?.rgb?.split(",")[0] || 0,
            g: itemData?.rgb?.split(",")[1] || 0,
            b: itemData?.rgb?.split(",")[2] || 0,
            hex: itemData?.hex || ''
        })
    }, [itemData])
    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            r: itemData?.rgb?.split(",")[0] || '',
            g: itemData?.rgb?.split(",")[1] || '',
            b: itemData?.rgb?.split(",")[2] || '',
            hex: itemData?.hex || '',
        },
        validationSchema: Yup.object({
        }),
        onSubmit: (values, { resetForm, setFieldValue }) => {
            values = {
                key_name: chartColorData?.key_name,
                rgb: `${rgb?.r},${rgb?.g},${rgb?.b}`,
                hex: rgb?.hex
            }
            if (isEdit) {
                dispatch(editChartColor(values, chartColorData?.id, (res) => {
                    if (res.status === 'success') {
                        toastr.success(res.message)
                        setRgb({ r: 0, g: 0, b: 0, hex: '' })
                          toggle()
                        fetchChartColorListData()
                      

                    } else {
                        toastr.error(res.message)
                        toggle()


                    }
                }));
            }

        }
    });

    const handleColorChange = (hex) => {
        let r = 0, g = 0, b = 0;
        if (hex.length === 4) {
            r = parseInt(hex[1] + hex[1], 16);
            g = parseInt(hex[2] + hex[2], 16);
            b = parseInt(hex[3] + hex[3], 16);
        } else if (hex.length === 7) {
            r = parseInt(hex[1] + hex[2], 16);
            g = parseInt(hex[3] + hex[4], 16);
            b = parseInt(hex[5] + hex[6], 16);
        }
        setRgb({
            r, g, b, hex
        })
    }

    const handleCopy = () => {
        toastr.success(props.t("Copied!!"))
    };

    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()

                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()

                    }}>
                    {!!isEdit ? props.t("Manage Chart Color") : props.t("Manage Chart Color")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-horizontal color-form-edit-main"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <div className="mb-3 d-flex align-items-center">
                            <Label className="form-label m-0 pb-1"><b>{props.t("Select Color")}:</b></Label>
                            <input type="color" value={rgb?.hex} onChange={(e) => handleColorChange(e.target.value)} />
                            {/* 
                            <Input
                                name="hex"
                                className="form-control"
                                type="color"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.hex || ""}
                                invalid={
                                    validation.touched.hex && validation.errors.hex ? true : false
                                }
                            /> */}
                        </div>

                        <div className="mb-3 d-flex align-items-center justify-spacebetween color-chart-modal">

                            <div className="inner-rgb hex-hash-box">
                                <Label className="form-label m-0 pb-1">{props.t("Hex")}:</Label>
                                <UncontrolledTooltip placement="top" target="userCopy">
                                    {props.t("Click to Copy")}
                                </UncontrolledTooltip>
                                <CopyToClipboard id="userCopy" text='j' onCopy={handleCopy}>
                                    <span style={{ fontSize: "13px", cursor: "pointer" }}><b>{rgb.hex}</b></span>
                                </CopyToClipboard>
                            </div>
                            <div className="inner-rgb">
                                <Label className="form-label m-0 pb-1">{props.t("R")}:</Label>
                                <Input
                                    name="r"
                                    className="form-control"
                                    type="text"
                                    value={rgb.r || ""}
                                    disabled
                                />
                            </div>
                            <div className="inner-rgb">
                                <Label className="form-label m-0 pb-1">{props.t("G")}:</Label>
                                <Input
                                    name="g"
                                    className="form-control"
                                    type="text"
                                    value={rgb.g || ""}
                                    disabled
                                />

                            </div>
                            <div className="inner-rgb">
                                <Label className="form-label m-0 pb-1">{props.t("B")}:</Label>
                                <Input
                                    name="b"
                                    className="form-control"
                                    type="text"
                                    value={rgb.b || ""}
                                    disabled
                                />
                            </div>
                        </div>

                        {
                            editLoading ?
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block d-flex"
                                        disabled
                                    >
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                        {props.t("Submit")}
                                    </button>
                                </div>
                                :
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                    // disabled
                                    >
                                        {props.t("Submit")}
                                    </button>
                                </div>
                        }
                    </Form>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};


AddEditModal.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(AddEditModal);

